'use strict';

class ChallengesNewController {
  constructor($q,
              $scope,
              $compile,
              $filter,
              $state,
              $timeout,
              utils,
              config,
              NgMap,
              NavigatorGeolocation,
              UsersService,
              GoogleMapsService,
              DevicesService,
              ChallengesService,
              TagsService,
              I18nService) {

    const $t = $filter('translate');
    const locale = I18nService.getLocale()?.code || 'en';
    const CURRENT_ORG_LOCAL_STORAGE_KEY = 'Organizations-Current';

    $scope.monthFormat = $t('datetime.challenges.month');
    $scope.dateFormat = $t('datetime.challenges.date');
    $scope.loading = true;

    $scope.orgInfo = utils.getStorageItem(CURRENT_ORG_LOCAL_STORAGE_KEY);

    // Set step to 2 for CC-599
    $scope.step = 2;
    $scope.totalStep = 2;

    $scope.challengeCategories = config.getConfigByKey('challengeCategories');
    $scope.challengeTypes = config.getConfigByKey('challengeIndividualTypes');
    $scope.optInStatuses = config.getConfigByKey('optInStatuses');
    $scope.savingsLevels = config.getConfigByKey('savingsLevels');
    $scope.deviceTypeExistance = config.getConfigByKey('deviceTypeExistance');
    $scope.thermostats = config.getConfigByKey('thermostats');

    angular.extend($scope, {
      compileRadios: compileRadios,
      gotoStep: gotoStep,
      refreshAccordionAndSlider: refreshAccordionAndSlider,
      sumPoints: sumPoints,
      isShowingMap: isShowingMap,
      createOrSaveChallenge: createOrSaveChallenge,
      saveReportCard: saveReportCard
    });

    getPopularTags();

    GoogleMapsService.getGoogleMapsUrl()
      .then((googleMapsUrl) => {
        $scope.googleMapsUrl = googleMapsUrl;
      });

    $scope.$watch('step', function() {
      if ($scope.isShowingMap()) {
        $timeout(function() { initWeatherDemandResponse(); }, 100);
      }

      $scope.stepStr = $t('challenges.step', {
        current: $scope.step,
        total: $scope.totalStep
      });
    });

    // Start Max Energy Savings
    let currentDate = new Date();
    let currentMonthDate = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);
    let nextMonthDate = utils.nextMonth(currentDate);

    let defaultDatePickerOptions = {
      language: locale,
      position: 'bottom left',
      autoClose: true
    };
    let defaultMonthDatePickerOptions = {
      view: 'months',
      minView: 'months',
      dateFormat: $scope.monthFormat,
      minDate: currentMonthDate
    };
    let defaultDateDatePickerOptions = {
      view: 'days',
      minView: 'days',
      dateFormat: $scope.dateFormat,
      minDate: new Date(),
      timepicker: true
    };

    $scope.startMonthDatePickerOptions = angular.extend({}, defaultDatePickerOptions, defaultMonthDatePickerOptions);
    $scope.endMonthDatePickerOptions = angular.extend({}, defaultDatePickerOptions, defaultMonthDatePickerOptions);

    $scope.startDatePickerOptions = angular.extend({}, defaultDatePickerOptions, defaultDateDatePickerOptions);
    $scope.endDatePickerOptions = angular.extend({}, defaultDatePickerOptions, defaultDateDatePickerOptions);

    setDatepickerMinAndMaxDate($scope.endMonthDatePickerOptions, utils.nextMonth(), null);

    $scope.$watch('startMonth', function(value) {
      if (value) {
        setDatepickerMinAndMaxDate($scope.endMonthDatePickerOptions, utils.nextMonth(new Date(value)), null);
      } else {
        setDatepickerMinAndMaxDate($scope.endMonthDatePickerOptions, utils.nextMonth(), null);
      }
    });

    $scope.$watch('endMonth', function(value) {
      if (value) {
        setDatepickerMinAndMaxDate($scope.startMonthDatePickerOptions, currentMonthDate, utils.preMonth(new Date(value)));
      } else {
        setDatepickerMinAndMaxDate($scope.startMonthDatePickerOptions, currentMonthDate, null);
      }
    });

    $scope.$watch('startDate', function(value) {
      if (value) {
        setDatepickerMinAndMaxDate($scope.endDatePickerOptions, new Date(value), null);
      } else {
        setDatepickerMinAndMaxDate($scope.endDatePickerOptions, currentDate, null);
      }
    });

    $scope.$watch('endDate', function(value) {
      if (value) {
        setDatepickerMinAndMaxDate($scope.startDatePickerOptions, currentDate, new Date(value));
      } else {
        setDatepickerMinAndMaxDate($scope.startDatePickerOptions, currentDate, null);
      }
    });

    $scope.$watch('noEndDate', function(value) {
      if (value) {
        setDatepickerMinAndMaxDate($scope.startMonthDatePickerOptions, currentMonthDate, null);
      } else {
        if ($scope.endMonth) {
          setDatepickerMinAndMaxDate($scope.startMonthDatePickerOptions, currentMonthDate, utils.preMonth(new Date($scope.endMonth)));
        }
      }
    });
    // End Max Energy Savings

    let promiseActives = getActiveChallenges();
    let promise1 = DevicesService.getDeviceTypes();
    $q.all([promise1, promiseActives])
      .then(function(result) {
        let data0 = result[0];
        let data1 = result[1];

        //init device types
        if (!$scope.orgInfo.deviceTypes) {
          $scope.deviceTypes = data0.deviceTypes;
        } else {
          let types = $scope.orgInfo.deviceTypes.split(',');
          $scope.deviceTypes = utils.convertKeysToItems(data0.deviceTypes, types, 'id');
        }

        //init existTypes
        $scope.existTypes = [];
        if (data1.challenges) {
          data1.challenges.forEach(function(item, index) {
            let type = utils.getChallengeType(item);
            if (!$.inArray(type, $scope.existTypes) != -1) {
              $scope.existTypes.push(type);
            }
          });
        }
        $scope.activeChallenges = data1.challenges;
        //init page
        initPage();
      });

    $.fn.form.settings.rules.startDateRule = value => angular.isDate($scope.startDate);
    $.fn.form.settings.rules.endDateRule = value => angular.isDate($scope.endDate);
    $.fn.form.settings.rules.startMonthRule = value => angular.isDate($scope.startMonth);
    $.fn.form.settings.rules.endMonthRule = value => $scope.noEndDate ? true : angular.isDate($scope.endMonth);
    $.fn.form.settings.rules.dateCompareRule = dateCompareRule;

    $.fn.form.settings.rules.participationStatusRule = value => !!value;
    $.fn.form.settings.rules.dropdownRule = value => !!value;
    $.fn.form.settings.rules.percentageRule = value => value >= 1 && value <= 100;
    $.fn.form.settings.rules.number = value => !isNaN(parseFloat(value)) && isFinite(value);
    $.fn.form.settings.rules.coordinates = (value, n) => {
      let flag = $.fn.form.settings.rules.number(value);
      if (flag) {
        if (n) {
          let arr = n.split('..');
          let min = arr.length >= 1 ? Number(arr[0]) : Number.MIN_VALUE,
            max = arr.length >= 2 ? Number(arr[1]) : Number.MAX_VALUE,
            valNum = Number(value) && parseInt(value);
          return valNum >= min & valNum <= max;
        } else {
          return true;
        }
      }
      return false;
    };

    // No code execution below this line. Only function definitions
    // --------------------------------------------------------------------

    function compileRadios() {
      let radio = $('#typeExistanceRadioList .ui.radio');
      $compile(radio)($scope);
      radio.checkbox({
        onChange: function() {
          $scope.deviceTypeExistanceId = this.value;
        }
      });
    }

    function getPopularTags() {
      return TagsService.getPopularTags($scope.orgInfo.id, 2)
        .then(function(data) {
          $scope.loading = false;
          $scope.locationTags = data.tags;
          return data;
        }, err => {
          $scope.loading = false;
          console.info(err);
        });
    }

    function gotoStep(step) {
      if (step <= $scope.totalStep) {
        $scope.step = step;
      } else {
        $state.go('main.challenges.list');
      }
    }

    // init page elements

    function setDatepickerMinAndMaxDate(options, minDate, maxDate) {
      options.minDate = minDate || '';
      options.maxDate = maxDate || '';
    }

    //end init page element

    function getActiveChallenges() {
      $scope.challenges = [];
      return ChallengesService.getChallenges($scope.orgInfo.id, { status: 1 });
    }

    function getReportCardChallenges() {
      $scope.challenges = [];
      return ChallengesService.getChallenges($scope.orgInfo.id);
    }

    function listReportCardChallenges(data) {
      if (data.challenges) {
        data.challenges.forEach(function(item, index) {
          if (item.challengeType == '3') { //report card
            $scope.reportCardChallenges.push(item);
          }
        });
      }
    }

    function refreshAccordionAndSlider() {
      $timeout(function() {
        $('.ui.accordion').accordion();
        $('.ui.slider').checkbox();
      }, 200);
    }

    function sumPoints(activities) {
      if (!activities || activities.length == 0) {
        return 0;
      }
      let sum = 0;
      for (let i = 0; i < activities.length; i++) {
        sum += activities[i].points;
      }
      return sum;
    }

    // Start WDR Map stuff
    function isShowingMap() {
      return $scope.step === 2 && $scope.selectedTypeId == '14001';
    }

    function initWeatherDemandResponse() {
      // Initialize map stuff (Cape Cod, US by default)
      $scope.defaultMapCenter = [41.66891793099595, -70.29606913862301];
      $scope.updateWeatherSourceFromMap = function(e) {
        setMarkerPosition(e.latLng.lat(), e.latLng.lng());
      };
      let setMarkerPosition = function(lat, lng) {
        $scope.latitude = lat;
        $scope.longitude = lng;
      };
      let updateMapCenter = function() {
        NgMap.getMap().then(function(map) {
          map.setCenter({ lat: $scope.latitude, lng: $scope.longitude });
        });
      };
      $scope.updateWeatherSourceFromMapAutocomplete = function() {
        let location = this.getPlace().geometry.location;
        setMarkerPosition(location.lat(), location.lng());
        updateMapCenter();
      };

      // Default marker position (will be overriden by geolocation if available)
      setMarkerPosition.apply(this, $scope.defaultMapCenter);
      // Try to get current user's position to center the map there. If n/a - use default location for map center
      NavigatorGeolocation.getCurrentPosition()
        .then(function(position) {
          if (position && position.coords) {
            setMarkerPosition(position.coords.latitude, position.coords.longitude);
          } else {
            setMarkerPosition.apply(this, $scope.defaultMapCenter);
          }
        }, function(rejected) {
          setMarkerPosition.apply(this, $scope.defaultMapCenter);
        }).then(function() {
        updateMapCenter();
      });

      // In order for the map to render tiles, we need to trigger resize event, since the map wasn't visible before
      NgMap.getMap().then(function(map) {
        // Tell map to incorporate search inputbox inside itself
        map.controls[google.maps.ControlPosition.TOP_LEFT].push($('#wdrMapAutocomplete')[0]);
        let center = map.getCenter();
        google.maps.event.trigger(map, 'resize');
        map.setCenter(center);
      });
    }

    // End WDR Map stuff

    function initPage() {
      $scope.selectedCategoryId = '1';

      // Only Demand Response type is available per CC-599
      $scope.selectedTypeId = '1400';

      $scope.$watch('selectedCategoryId', function(newValue, oldValue) {
        if (newValue == '0') {
          $scope.challengeTypes = config.getConfigByKey('challengeGroupTypes');
        } else if (newValue == '1') {
          $scope.challengeTypes = config.getConfigByKey('challengeIndividualTypes');
        }
      });

      $scope.$watch('selectedTypeId', function(newValue, oldValue) {
        if (newValue) {
          // Disabled for reason of bug during switch different DR types
          //$("#form-details").form("clear");
          $scope.existActiveChallenge = $.inArray(newValue, $scope.existTypes) != -1;
        }
        if (newValue == '1300') { //report card
          $scope.reportCardChallenges = [];
          getReportCardChallenges().then(function(data) {
            listReportCardChallenges(data);
            // Goto next step
          });
        } else if (newValue == '1400' || newValue == '14001') { // demand response
          $scope.participantStatus = '2';
          $scope.deviceTypeExistanceId = '1';
          $scope.thermostatsId = '0';
          //$scope.participantTag = '';
          //$scope.excludeParticipantTag = '';

          // Set predefined device types for CC-599
          let demandResponseTypes = ['10037', '4240', '4230', '10035', '9017'];
          let selectedTypes = [];
          demandResponseTypes.forEach(el => {
            let found = $scope.deviceTypes.find(type => {
              return type.id.toString() === el;
            });
            if (found) {
              selectedTypes.push(el);
            }
          });

          $scope.selectedDeviceTypeIds = selectedTypes;
          $scope.selectedDeviceTypeIdsExclude = null;
          $scope.savingsLevel = '3';
          $scope.percentageHomes = '25';
        }

        if ($scope.selectedTypeId) {
          initForms();
        }
      });
    }

    function initForms() {
      if ($scope.selectedTypeId == '1300') { // Report cards

      } else if ($scope.selectedTypeId == '1103') { // Savings goal

        $('#form-details').form({
          inline: true,
          fields: {
            'goal': {
              rules: [
                {
                  type: 'empty',
                  prompt: $t('prompt.challenges.goal.empty')
                }
              ]
            },
            'prize': {
              rules: [
                {
                  type: 'empty',
                  prompt: $t('prompt.challenges.prize.empty')
                }
              ]
            }
          }
        });

      } else if ($scope.selectedTypeId == '1110' || $scope.selectedTypeId == '0110') { // Max energy savings

        $('#form-details').form({
          inline: true,
          fields: {
            'name': {
              rules: [
                {
                  type: 'empty',
                  prompt: $t('prompt.challenges.name.empty')
                }
              ]
            },
            'prize1st': {
              rules: [
                {
                  type: 'empty',
                  prompt: $t('prompt.challenges.1st-prize.empty')
                }
              ]
            },
            'prize2nd': {
              rules: [
                {
                  type: 'empty',
                  prompt: $t('prompt.challenges.2nd-prize.empty')
                }
              ]
            },
            'prize3rd': {
              rules: [
                {
                  type: 'empty',
                  prompt: $t('prompt.challenges.3rd-prize.empty')
                }
              ]
            },
            'date-start-month': {
              rules: [
                {
                  type: 'startMonthRule',
                  prompt: $t('prompt.challenges.date-start-month')
                }
              ]
            },
            'date-end-month': {
              rules: [
                {
                  type: 'endMonthRule',
                  prompt: $t('prompt.challenges.date-end-month')
                }
              ]
            }
          }
        });

      } else if ($scope.selectedTypeId == '1100' || $scope.selectedTypeId == '0100') { // Old DR

        $('#form-details').form({
          inline: true,
          fields: {
            'name': {
              rules: [
                {
                  type: 'empty',
                  prompt: $t('prompt.challenges.name.empty')
                }
              ]
            },
            // Excluded for CC-599
            // 'goal': {
            //   rules: [
            //     {
            //       type: 'empty',
            //       prompt: $t('prompt.challenges.goal.empty')
            //     }
            //   ]
            // },
            'prize': {
              rules: [
                {
                  type: 'empty',
                  prompt: $t('prompt.challenges.prize.empty')
                }
              ]
            },
            'date-start': {
              rules: [
                {
                  type: 'startDateRule',
                  prompt: $t('prompt.challenges.date-start')
                }
              ]
            },
            'date-end': {
              rules: [
                {
                  type: 'endDateRule',
                  prompt: $t('prompt.challenges.date-end')
                }, {
                  type: 'dateCompareRule',
                  prompt: $t('prompt.challenges.time-end.compare')
                }
              ]
            }
          }
        });

      } else if ($scope.selectedTypeId == '0200') { // Recruiting

        $('#form-details').form({
          inline: true,
          fields: {
            'name': {
              rules: [
                {
                  type: 'empty',
                  prompt: $t('prompt.challenges.name.empty')
                }
              ]
            },
            'prize1st': {
              rules: [
                {
                  type: 'empty',
                  prompt: $t('prompt.challenges.1st-prize.empty')
                }
              ]
            },
            'prize2nd': {
              rules: [
                {
                  type: 'empty',
                  prompt: $t('prompt.challenges.2nd-prize.empty')
                }
              ]
            },
            'prize3rd': {
              rules: [
                {
                  type: 'empty',
                  prompt: $t('prompt.challenges.3rd-prize.empty')
                }
              ]
            },
            'date-start': {
              rules: [
                {
                  type: 'startDateRule',
                  prompt: $t('prompt.challenges.date-start')
                }
              ]
            },
            'date-end': {
              rules: [
                {
                  type: 'endDateRule',
                  prompt: $t('prompt.challenges.date-end')
                }, {
                  type: 'dateCompareRule',
                  prompt: $t('prompt.challenges.time-end.compare')
                }
              ]
            }
          }
        });

      } else if ($scope.selectedTypeId == '1400') { // New DRnchallenge

        $('#form-details').form({
          inline: true,
          fields: {
            'name': {
              rules: [
                {
                  type: 'empty',
                  prompt: $t('prompt.challenges.name.empty')
                }
              ]
            },
            // Excluded for CC-599
            // 'goal': {
            //   rules: [
            //     {
            //       type: 'empty',
            //       prompt: $t('prompt.challenges.goal.empty')
            //     }
            //   ]
            // },
            'input-hidden-dropdown-participation-status': {
              rules: [
                {
                  type: 'participationStatusRule',
                  prompt: $t('prompt.challenges.participation-status.empty')
                }
              ]
            },
            'date-start': {
              rules: [
                {
                  type: 'startDateRule',
                  prompt: $t('prompt.challenges.date-start')
                }
              ]
            },
            'date-end': {
              rules: [
                {
                  type: 'endDateRule',
                  prompt: $t('prompt.challenges.date-end')
                },
                {
                  type: 'dateCompareRule',
                  prompt: $t('prompt.challenges.time-end.compare')
                }
              ]
            },
            'input-hidden-dropdown-deviceTypes': {
              rules: [
                {
                  type: 'dropdownRule',
                  prompt: $t('prompt.challenges.device-types.empty')
                }
              ]
            },
            'input-hidden-dropdown-savings-level': {
              rules: [
                {
                  type: 'dropdownRule',
                  prompt: $t('prompt.challenges.savings-level.empty')
                }
              ]
            },
            'homes': {
              rules: [
                {
                  type: 'empty',
                  prompt: $t('prompt.challenges.homes.empty')
                },
                {
                  type: 'percentageRule',
                  prompt: $t('prompt.challenges.homes.invalid')
                }
              ]
            }
          }
        });

      } else if ($scope.selectedTypeId == '14001') { // Weather DR

        $('#form-details').form({
          inline: true,
          fields: {
            'name': {
              rules: [
                {
                  type: 'empty',
                  prompt: $t('prompt.challenges.name.empty')
                }
              ]
            },
            'input-hidden-dropdown-participation-status': {
              rules: [
                {
                  type: 'participationStatusRule',
                  prompt: $t('prompt.challenges.participation-status.empty')
                }
              ]
            },
            'date-start': {
              rules: [
                {
                  type: 'startDateRule',
                  prompt: $t('prompt.challenges.date-start')
                }
              ]
            },
            'date-end': {
              rules: [
                {
                  type: 'endDateRule',
                  prompt: $t('prompt.challenges.date-end')
                }, {
                  type: 'dateCompareRule',
                  prompt: $t('prompt.challenges.time-end.compare')
                }
              ]
            },
            'input-hidden-dropdown-deviceTypes': {
              rules: [
                {
                  type: 'dropdownRule',
                  prompt: $t('prompt.challenges.device-types.empty')
                }
              ]
            },
            'input-hidden-dropdown-savings-level': {
              rules: [
                {
                  type: 'dropdownRule',
                  prompt: $t('prompt.challenges.savings-level.empty')
                }
              ]
            },
            'homes': {
              rules: [
                {
                  type: 'empty',
                  prompt: $t('prompt.challenges.homes.empty')
                }, {
                  type: 'percentageRule',
                  prompt: $t('prompt.challenges.homes.invalid')
                }
              ]
            },
            'latitude': {
              rules: [
                {
                  type: 'empty',
                  prompt: $t('prompt.challenges.homes.empty')
                }, {
                  type: 'coordinates[-90..90]',
                  prompt: $t('prompt.locations.latitude')
                }
              ]
            },
            'longitude': {
              rules: [
                {
                  type: 'empty',
                  prompt: $t('prompt.challenges.homes.empty')
                }, {
                  type: 'coordinates[-180..180]',
                  prompt: $t('prompt.locations.longitude')
                }
              ]
            }
          }
        });

      }
    }

    function createOrSaveChallenge() {
      if ($scope.selectedTypeId == '1300') { // Report cards
        saveReportCards();
      } else if ($scope.selectedTypeId == '1103') { // Savings goal
        saveSavingsGoal();
      } else if ($scope.selectedTypeId == '1110' || $scope.selectedTypeId == '0110') { // Max energy savings
        saveMaxEnergySavings();
      } else if ($scope.selectedTypeId == '1100' || $scope.selectedTypeId == '0100') { // Old DR
        saveDemandResponse();
      } else if ($scope.selectedTypeId == '0200') { // Recruiting
        saveRecruiting();
      } else if ($scope.selectedTypeId == '1400') { // New DRnchallenge
        saveNewDemandResponse();
      } else if ($scope.selectedTypeId == '14001') { // Weather DR
        saveWeatherDemandResponse();
      }
    }

    function saveSuccess() {
      $state.go('main.challenges.list');
    }

    function saveReportCards() {
      $q.all($scope.reportCardChallenges.map(c => $scope.saveReportCard(c)))
        .then(() => {
          saveSuccess();
        });
    }

    function saveReportCard(challenge) {
      let promise1 = ChallengesService
        .updateChallengeStatus($scope.orgInfo.id, challenge.challengeId, challenge.status);

      let updateActivityModel = {
        'challenge': {
          'activity': challenge.activities.map(item => ({
            id: item.activityId ? item.activityId : void 0,
            name: item.name,
            points: item.points,
            status: item.status,
          }))
        }
      };
      let promise2 = ChallengesService
        .createOrUpdateActivity($scope.orgInfo.id, challenge.challengeId, updateActivityModel);

      return $q.all([promise1, promise2]);
    }

    function createChallenge(challenge, checked) {
      let params = {
        timeZone: utils.getBrowserTimezone()
      };
      if (checked) {
        params.checked = true;
      }
      return ChallengesService.createChallenge($scope.orgInfo.id,
        { 'challenge': challenge }, params);
    }

    function saveSavingsGoal() {
      // $('#form-details').form('validate form');
      let flag = $('#form-details').form('is valid');
      if (!flag) {
        return;
      }

      let type = config.getConfigItemByKeyAndId('challengeTypes', $scope.selectedTypeId);
      let challenge = {
        'name': $t(type.name),
        'challengeType': type.challengeType,
        'recurring': type.recurring,
        'participantType': type.participantType,
        'winnerType': type.winnerType,
        'goal': $scope.goal,
        'prize': [
          {
            'place': 1,
            'prize': $scope.prize,
          }
        ]
      };
      createChallenge(challenge)
        .then(() => {
          saveSuccess();
        });
    }

    function saveMaxEnergySavings() {

      // $('#form-details').form('validate form');
      let flag = $('#form-details').form('is valid');
      if (!flag) {
        return;
      }
      let type = config.getConfigItemByKeyAndId('challengeTypes', $scope.selectedTypeId);
      let challenge = {
        'name': $scope.challengeName,
        'challengeType': type.challengeType,
        'recurring': $scope.noEndDate ? 3 : 0,
        'startDate': $scope.startMonth.getTime(),
        'participantType': type.participantType,
        'winnerType': type.winnerType,
        'prize': [
          {
            'place': 1,
            'prize': $scope.prize1st
          }, {
            'place': 2,
            'prize': $scope.prize2nd
          }, {
            'place': 3,
            'prize': $scope.prize3rd
          }
        ]
      };

      if (!$scope.noEndDate) {
        challenge.endDate = $scope.endMonth.getTime();
      }
      createChallenge(challenge)
        .then(() => {
          saveSuccess();
        });
    }

    function dateCompareRule(value) {
      let startDate = $scope.startDate;
      let endDate = $scope.endDate;
      if (startDate && endDate) {
        $scope.startDateMs = startDate.getTime();
        $scope.endDateMs = endDate.getTime();
        return $scope.endDateMs - $scope.startDateMs > 0;
      }
      return false;
    }

    function saveDemandResponse() {
      // $('#form-details').form('validate form');
      let flag = $('#form-details').form('is valid');
      if (!flag) {
        return;
      }

      let type = config.getConfigItemByKeyAndId('challengeTypes', $scope.selectedTypeId);
      let challenge = {
        'name': $scope.challengeName,
        'challengeType': type.challengeType,
        'recurring': type.recurring,
        'participantType': type.participantType,
        'winnerType': type.winnerType,
        // Excluded for CC-599
        // 'goal': $scope.goal,
        'startDate': $scope.startDateMs,
        'endDate': $scope.endDateMs,
        'prize': [
          {
            'place': 1,
            'prize': $scope.prize
          }
        ]
      };

      createChallenge(challenge).then(function(data) {
        if (data.resultCode != 0) {
          return;
        }
        saveSuccess();
      });
    }

    function saveRecruiting() {
      // $('#form-details').form('validate form');
      let flag = $('#form-details').form('is valid');
      if (!flag) {
        return;
      }
      let type = config.getConfigItemByKeyAndId('challengeTypes', $scope.selectedTypeId);
      let challenge = {
        'name': $scope.challengeName,
        'challengeType': type.challengeType,
        'recurring': type.recurring,
        'participantType': type.participantType,
        'winnerType': type.winnerType,
        'startDate': $scope.startDateMs,
        'endDate': $scope.endDateMs,
        'prize': [
          {
            'place': 1,
            'prize': $scope.prize1st
          }, {
            'place': 2,
            'prize': $scope.prize2nd
          }, {
            'place': 3,
            'prize': $scope.prize3rd
          }
        ]
      };

      createChallenge(challenge).then(function(data) {
        if (data.resultCode != 0) {
          return;
        }
        saveSuccess();
      });
    }

    // New DR challenge
    function saveNewDemandResponse() {
      $('#form-details').form('validate form');
      let flag = $('#form-details').form('is valid');
      if (!flag) {
        $(document).scrollTop(false);
        return;
      }

      let type = config.getConfigItemByKeyAndId('challengeTypes', $scope.selectedTypeId);
      let challenge = {
        'name': $scope.challengeName,
        'challengeType': type.challengeType,
        'recurring': type.recurring,
        'participantType': parseInt(type.participantType),
        'winnerType': type.winnerType,
        // Excluded for CC-599
        // 'goal': $scope.goal,
        'startDate': $scope.startDateMs,
        'endDate': $scope.endDateMs,
        'deviceTypeExistance': parseInt($scope.deviceTypeExistanceId),
        'participantStatus': $scope.participantStatus,
        'deviceTypes': $scope.selectedDeviceTypeIds,
        'invitational': true,
        'parameters': {
          'percent_relief': $scope.percentageHomes,
          'simple': $scope.savingsLevel
        }
      };

      if ($scope.participantTag && $scope.participantTag.length > 0) {
        challenge.participantTag = $scope.participantTag.toString();
      }
      if ($scope.excludeParticipantTag) {
        challenge.excludeParticipantTag = $scope.excludeParticipantTag;
      }
      if ($scope.selectedDeviceTypeIdsExclude) {
        challenge.excludeDeviceTypes = $scope.selectedDeviceTypeIdsExclude;
      }

      // Optional parameters
      if ($scope.comment) {
        challenge.parameters.vtn_comment = $scope.comment;
      }

      createChallenge(challenge)
        .then(() => {
          saveSuccess();
        });
    }

    // New Weather DR challenge
    function saveWeatherDemandResponse() {
      // $('#form-details').form('validate form');
      let flag = $('#form-details').form('is valid');
      if (!flag) {
        return;
      }
      let type = config.getConfigItemByKeyAndId('challengeTypes', $scope.selectedTypeId);
      let challenge = {
        'name': $scope.challengeName,
        'template': true,
        'challengeType': type.challengeType,
        'recurring': type.recurring,
        'participantType': parseInt(type.participantType),
        'winnerType': type.winnerType,
        'startDate': $scope.startDateMs,
        'endDate': $scope.endDateMs,
        'deviceTypeExistance': parseInt($scope.deviceTypeExistanceId),
        'participantStatus': $scope.participantStatus,
        'deviceTypes': $scope.selectedDeviceTypeIds,
        'invitational': true,
        'parameters': {
          'percent_relief': $scope.percentageHomes,
          'simple': $scope.savingsLevel,
          'latitude': $scope.latitude,
          'longitude': $scope.longitude
        }
      };

      if ($scope.participantTag) {
        challenge.participantTag = $scope.participantTag;
      }
      if ($scope.excludeParticipantTag) {
        challenge.excludeParticipantTag = $scope.excludeParticipantTag;
      }
      if ($scope.selectedDeviceTypeIdsExclude) {
        challenge.excludeDeviceTypes = $scope.selectedDeviceTypeIdsExclude;
      }

      // Optional parameters
      if ($scope.tempThreshold) {
        challenge.parameters.temperature_threshold_c = $filter('F2C')($scope.tempThreshold);
      }
      if ($scope.humidityThreshold) {
        challenge.parameters.humidity_threshold = $scope.humidityThreshold;
      }
      if ($scope.indexThreshold) {
        challenge.parameters.heatindex_threshold_c = $filter('F2C')($scope.indexThreshold);
      }

      createChallenge(challenge, false)
        .then(() => {
          saveSuccess();
        });
    }
  }
}

export default angular
  .module('main.challengesNew.controller', [])
  .controller('ChallengesNewController', ChallengesNewController)
  .name;
